var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('a-layout',[(_vm.$store.state.userInfo.company_id != 0 && _vm.$store.state.userInfo.status == 1)?_c('a-layout-header',[_c('Header')],1):_vm._e(),_c('a-layout',[_c('a-layout-sider',[_c('Sider')],1),_c('a-layout-content',[_c('router-view')],1)],1),_c('a-layout-footer',[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }